import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ABCisTableModel, ColumnData, ColumnType, ColumnValues, MatchMode } from 'src/app/components/abcis-table/abcis-table.component';
import { ABCisApi } from 'src/app/handlers/apiHandler.service';
import { General } from 'src/app/constants/constants';
import { Validators } from '@angular/forms';

@Component({
  selector: 'app-master-product-table',
  standalone: false,
  templateUrl: './master-product-table.component.html',
  styleUrls: ['./master-product-table.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class MasterProductTableComponent implements OnInit {
  @Output() onSelectRow = new EventEmitter<any>();
  @Output() onUnSelectRow = new EventEmitter<any>();

  public masterTableConfig: ABCisTableModel;
  public selectedMasterProduct: any;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.setTableConfiguration();
  }
  setTableConfiguration() {
    // Route the users filter results. For sharing
    this.masterTableConfig = {
      apiConfig: { api: ABCisApi.Ocr, table: 'null', url: 'master-product/master-product/table', approxamateRowCount: 1000, anyParams: true },
      colConfig: [
        { field: 'description', header: 'Description', type: ColumnType.String, addFormErrorMessages: [{ key: 'required', message: 'Description is required.' }], addFormValidators: [Validators.required], width: '700px'},
        { field: 'plu', header: 'PLU', type: ColumnType.String, limit: 14, accept: ColumnValues.Number, width: '400px', addFormErrorMessages: [{ key: 'required', message: 'PLU is required.' }, { key: 'minlength', message: 'PLU must be 14 digits.' }], addFormValidators: [Validators.required, Validators.minLength(14), Validators.maxLength(14)] },
        { field: 'cartonQuantity', sortable: false, header: 'Carton Quantity', type: ColumnType.Number, width: '400px' },
        { field: 'productId', header: 'Product Id', type: ColumnType.String, isReadonly: true, isPrimary: true, notInForm: true, isHidden: true },
        { field: 'descriptionId', header: '', type: ColumnType.String, isReadonly: true, notInForm: true, isHidden: true },
        { field: 'gtinId', header: '', type: ColumnType.String, isReadonly: true, notInForm: true, isHidden: true }
      ],
      addFormConfig: { header: 'Add Master Product' },
      metaKeySelection: false,
      selectionMode: 'single',
      isConfigurable: true,
      isTable: false,
    };
  }

  onRowSelect($event) {
    this.onSelectRow.next($event);
  }

  onRowUnselect($event) {
    this.onUnSelectRow.next($event);
  }
}
